(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('analytics', {
            parent: 'app',
            url: '/analytics',
            data: {
                authorities: ['ROLE_BI_VIEWER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/displays/analytics/analytics.html',
                    controller: 'AnalyticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
